 'use strict'

 /**
  * @classname BtnDisabledUntilRelevantFieldsEntered
  * @classdesc 関連する項目が入力されるまでボタンをdisabledにする
  */
export default class BtnDisabledUntilRelevantFieldsEntered {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-disabled-until-relevant-fields-entered')
	 */
	constructor($e, controller) {
		console.log('BtnDisabledUntilRelevantFieldsEntered.constructor')
		this._$e = $e
		this._controller = controller
		this.initialize()
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnDisabledUntilRelevantFieldsEntered
	 * @return {undefined}
	 */
	initialize() {
		console.log(`BtnDisabledUntilRelevantFieldsEntered.initialize`)
		console.log(this._$e)
		this._$e.data('required-element-selectors').split(' ').forEach(selector => {
			if ($(selector).val() != '') {
				this._$e
					.prop('disabled', false)
					.find('.custom-tooltip')
					.hide()
			} else {
				this._$e
					.prop('disabled', true)
					.find('.custom-tooltip')
					.show()
			}
		})
		this.setEvent()
	}


	/**
	 * イベントをセット
	 *
	 * @memberof BtnDisabledUntilRelevantFieldsEntered
	 * @return {undefined}
	 */
	setEvent() {
		console.log(`BtnDisabledUntilRelevantFieldsEntered.setEvent`)
		this._$e.data('required-element-selectors').split(' ').forEach(selector => {
			$(selector).on('input', () => {
				if ($(selector).val() != '') {
					this._$e
						.prop('disabled', false)
						.find('.custom-tooltip')
						.hide()
				} else {
					let validity = true
					this._$e.data('required-element-selectors').split(' ').forEach(selector => {
						if ($(selector).val() == '') validity = false
					})
					if (validity) {
						this._$e
							.prop('disabled', false)
							.find('.custom-tooltip')
							.hide()
					} else {
						this._$e
							.prop('disabled', true)
							.find('.custom-tooltip')
							.show()
					}
				}
			})
		})
	}
}
